module.exports = __webpack_public_path__ + "static/media/lightbulb.b993a089.svg";